<template>
  <v-textarea
    v-model="model"
    :label="$t('description')"
    auto-grow
    :loading="loading"
    rows="1"
    solo
    flat
    :outlined="outlined"
    row-height="1"
    clearable
    style="height: 35px"
    @blur="$emit('blur', model)"
  >
    <!--   list of items of description -->
    <template
      v-slot:append-outer
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            x-small
            color="grey"
            style="margin-top: 2px;"
            v-on="on"
            @click="dialog = true"
          >
            <v-icon
              style="font-size: 20px"
            >
              mdi-format-list-checks
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('draft') }}</span>
      </v-tooltip>
      <!--      dialog draft-->
          <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
        v-model="dialog"
        width="95%"
        style="height: auto"
      >
        <v-card flat>
          <v-card-title>
            {{ $t('draft-list') }}
          </v-card-title>
          <v-card-text>
            <v-container
              style="height: auto"
            >
              <v-row class="mx-0">
                <v-col
                  class="pb-0"
                  cols="10"
                >
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('search')"
                    outlined
                    height="30"
                    dense
                  />
                </v-col>
                <v-col
                  class="pb-0"
                  cols="2"
                >
                  <export-excel
                    :data="items"
                    worksheet="abriron.com"
                    name="data-ai.xlsx"
                    class="float-left"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            style="font-size: 24px"
                            color="green"
                          >
                            mdi-file-excel-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('excel') }}</span>
                    </v-tooltip>
                  </export-excel>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        icon
                        class="float-left"
                        v-on="on"
                      >
                        <v-icon
                          color="primary"
                          style="font-size: 24px"
                          @click="print"
                        >
                          mdi-cloud-print-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('print') }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-col
                id="print"
                cols="12"
              >
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  :loading="loading"
                  multi-sort
                  single-select
                  item-key="id"
                  show-select
                >
                  <template v-slot:item.actions="{ item }">
                    <v-menu
                      offset-y
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            medium
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          link
                          @click="remove(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                  <template v-slot:item.id="{ item }">
                    {{ items.indexOf(item)+from }}
                  </template>
                  <template v-slot:item.text="{ item }">
                    {{ item.text }}
                  </template>
                </v-data-table>
              </v-col>
              <v-row />
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              depressed
              color="error"
              text
              @click="dialog = false"
            >
              {{ $t('close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <!--    add and store description-->
    <template
      v-if="model != temp"
      v-slot:append
    >
      <v-tooltip
        bottom
      >
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            v-bind="attrs"
            icon
            x-small
            style="margin-top: 2px;"
            color="primary"
            v-on="on"
            @click="store"
          >
            <v-icon
              style="font-size: 20px"
              v-on="on"
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </template>
        {{ $t('add-to-draft') }}
      </v-tooltip>
    </template>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
    />
  </v-textarea>
</template>

<script>
  export default {
    name: 'Description',
    components: {
      Snakbar: () => import('../snakbar/snakbar'),
    },
    props: ['input', 'type', 'data', 'outlined', 'value'],
    data: () => ({
      selected: [],
      model: null,
      from: 1,
      temp: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      search: null,
    }),
    watch: {
      value () {
        this.model = this.value
      },
      data (val, oldVal) {
        this.model = val.description
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected[0].text)
        this.model = this.selected[0].text
        this.temp = this.selected[0].text
        this.dialog = false
      },
      dialog () {
        if (this.dialog) {
          this.getItems()
        }
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated: function () {
      this.getItems()
    },
    beforeMount () {
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'id',
          table: 'descriptions.id',
        },
        {
          text: this.$t('description'),
          sortable: true,
          value: 'text',
          table: 'descriptions.text',
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      if (this.value) {
        this.model = this.value
      }
    },
    mounted () {
      this.getItems()
    },
    methods: {
      setData (val) {
        this.model = val
      },
      store () {
        var app = this
        app.loading = true
        app.$axios.post(this.$endpoint + 'descriptions', {
          text: app.model,
          type: app.type,
        })
          .then(res => {
            res = res.data
            app.temp = app.model
            app.$emit('input', app.model)
          })
          .finally(() => (app.loading = false))
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'descriptions/show', {
          params: {
            search: app.search,
            page: app.options.page,
            type: app.type,
            sortBy: app.sortBy,
            options: app.options,
          },

        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.from = res.from
          })
          .finally(() => (app.loading = false))
      },
      remove (item) {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'descriptions/' + item.id)
          .then(res => {
            res = res.data
            app.items.splice(app.items.indexOf(item), 1)
          })
          .finally(() => (app.loading = false))
      },
      print () {
        this.$htmlToPaper('print')
      },
    },
  }
</script>

<style scoped>

</style>
